import { ILexingError, IRecognitionException } from 'chevrotain';
import { DocumentNode } from 'graphql';
import * as monacoEditor from 'monaco-editor';

import { cstToSchema } from './cstToSchema';
import { parseSchemaCST } from './parseSchemaCST';

let lastRun:
  | {
      documentText: string;
      result: {
        documentNode: DocumentNode;
        lexErrors: ILexingError[];
        parseErrors: IRecognitionException[];
      };
    }
  | undefined;

export function tolerantParseSchema(
  model: monacoEditor.editor.ITextModel,
  serviceName?: string,
) {
  const documentText = model.getValue();
  if (!lastRun || documentText !== lastRun.documentText) {
    const { value, lexErrors, parseErrors } = parseSchemaCST(documentText);
    const { documentNode } = cstToSchema(value, model, serviceName);
    lastRun = {
      documentText,
      result: { documentNode, lexErrors, parseErrors },
    };
  }
  return lastRun.result;
}
